<template>
  <div>
    <SiteHeader v-if="showHeader"></SiteHeader>
    <main id="maincontent" role="main">
      <div id="breadcrumb">&nbsp;</div>
    <router-view/>
    </main>
    <SiteFooter v-if="showHeader"></SiteFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'

export default {
  components: {
    SiteHeader,
    SiteFooter
  },
  computed: {
    ...mapState('loginStore', ['userProfile']),
    //
    showHeader() {
      return Object.keys(this.userProfile).length > 1
    }
  }
}
</script>
